export const stageTipList=[
    {
        id:1,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'故事梗概（一句话/五百字）、世界观设定文档、参考影片与视觉风格片单、核心创意提案PPT'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'完整分集大纲、详细人物小传与关系图、分场景剧本、美术风格设定集（概念图）、分镜头脚本初稿、拍摄场地勘察报告'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'审定版分镜头脚本、拍摄日程表、现场场记单、原始拍摄素材（视频/音频）、特效制作工程文件、配音演员试音文件、道具服装设计图'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'最终剪辑成片（不同分辨率版本）、DCP打包文件、片头片尾动态设计文件、海报与高清剧照、官方预告片、完整的对白字幕文件（SRT等）'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'《国产片上映许可证》、网络平台上线协议、票房/播放量数据报告、衍生品（手办、服饰）设计图、OST原声带发行合同、电影节参展证明'
            }
        ]
    },
    {
        id:2,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'灵感速记、主题列表、片段手稿、人物原型设定、关键词脑图'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'详细章节目录、人物关系图、情节发展线图、场景描写详纲、参考文献目录'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'各章节初稿、修订版本对比稿、批注与编辑意见稿、实地调研笔记、采访录音转录稿'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'最终定稿的电子文档（Word/PDF）、印刷排版文件、封面设计稿、内容摘要、作者序言'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'出版合同、ISBN条码、网络连载平台发布页截图、书籍销售链接、影视/游戏改编授权协议、翻译授权合同'
            }
        ]
    },
    {
        id:3,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'拍摄主题阐述、灵感参考图集、拍摄地点与对象调研笔记'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'拍摄计划书（时间、器材、光线）、草图或构图预想图、模特/场景选择方案'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'原始RAW格式照片文件、同一场景不同参数/角度连拍序列、拍摄现场工作照/花絮视频、器材及参数记录'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'精选并精修后的成品照片（高清大图及网络用图）、作品标题与阐述文字、组图编排顺序方案'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'展览展出证明、摄影画册印刷文件、参赛获奖证书、商业图库销售授权书、被媒体采用的截图及链接'
            }
        ]
    },
    {
        id:4,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'灵感来源照片/实物、色彩小稿、多种构图草稿、材料实验小样'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'确定稿的素描线稿、详细的色彩方案（色卡）、画布/材料准备记录、最终尺寸与装裱方案'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'绘画过程分步骤记录照片或延时摄影、重要修改图层文件、特殊技法应用记录'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'作品完成后的高清多角度细节照片、在标准光源下的展示照片、作品背面信息（签名、日期）照片'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'画廊代理合同、拍卖图录、个人作品集出版页、收藏机构出具的收藏证书、展览现场照片与画册'
            }
        ]
    },
    {
        id:5,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'哼唱或乐器演奏的旋律动机录音片段、歌词灵感文本、情绪与风格描述'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'完整的歌曲结构谱（主歌、副歌、桥段等）、和声进行设计文档、配器方案、歌词初稿'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'编曲工程文件（如Cubase/Logic工程）、乐器分轨录音原始文件、人声干声音频、MIDI音符文件、混音师沟通记录'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'最终立体声混音母带（WAV格式）、分轨混音文件、官方歌词文本文件、专辑封面设计稿'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'在音乐平台（如Spotify、QQ音乐）的发行后台截图、演出表演权许可合同、KTV曲库入库证明、被影视剧采用的同步授权合同'
            }
        ]
    },
    {
        id:6,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'设计简报、头脑风暴思维导图、竞品分析图、初步概念草图'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'用户画像、用户旅程地图、线框图、交互流程图、视觉风格指南初稿、色彩与字体规范、高保真原型'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'UI设计源文件（Sketch/Figma/PSD）、切图资源包、交互动效演示文件、3D渲染源文件、实物打样照片'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'最终交付的设计图（所有尺寸与格式）、设计规范手册、产品实物终版照片、设计作品登记图'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'设计专利证书、客户验收确认单、量产文件（如印刷文件、模具图纸）、设计奖项获奖证书、作品被商业应用的场景照片'
            }
        ]
    },
    {
        id:7,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'演讲/授课主题提纲、核心观点列表、案例素材收集'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'完整的逐字稿或详细提纲、演讲PPT初稿、现场互动环节设计'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'排练试讲录音/录像、根据反馈修改的讲稿版本、最终版演示文稿（PPT/Keynote）'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'正式场合的完整录音或录像、现场听众笔记或反馈照片、整理后的文字实录稿'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'讲座海报与新闻稿、在线课程平台发布页、知识付费产品销售链接、讲稿被收录出版的合同'
            }
        ]
    },
    {
        id:8,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'剧本故事核、人物雏形、希望表达的核心思想'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'完整剧本（对白、舞台提示）、导演阐述、舞美/灯光/服装初步设计图'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'排练录像（不同阶段）、音乐音效设计稿与素材、服装道具制作图与样品照片、舞台布景制作记录'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'正式公演的全程舞台录像（多机位）、定妆照、节目单、舞美竣工图、灯光cue表'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'演出批文、票务销售记录、剧评报道、巡演合同、剧本出版或影视改编权转让协议'
            }
        ]
    },
    {
        id:9,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'作品主题与情感基调描述、核心动作动机视频片段'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'完整的舞蹈动作编排谱（舞谱）、音乐选定或创作说明、服装与造型设计图'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'分段排练录像、与编舞师的沟通记录、音乐剪辑与合成工程文件、技巧难点训练记录'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'完整表演的舞台录像（带观众反应）、后台纪录片花絮、定妆照、音乐最终混音文件'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'演出合同与演出许可证、参赛视频及获奖证书、教学视频制作母带、动作编排被其他团体使用的授权协议'
            }
        ]
    },
    {
        id:10,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'概念设计草图、场地分析图（日照、风向）、设计任务书'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'方案设计文本、总平面图、各层平面/立面/剖面图、效果图、实体或数字概念模型'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'方案设计文本、总平面图、各层平面/立面/剖面图、效果图、实体或数字概念模型'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'建筑竣工实景照片与视频、航拍图、竣工图、主要空间室内照片、获得的质量认证（如LEED）'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'建设工程规划许可证、竣工验收备案表、获奖证书、在专业媒体发表的文章、建筑被列入保护名录的文件'
            }
        ]
    },
    {
        id:11,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'图表要表达的数据关系构思、示意图要说明的原理草图'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'数据整理文档、图表类型选择依据、图形绘制线稿、图例与标注设计说明'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'矢量绘图源文件（AI/EPS）、数据可视化编程脚本（如Python）、三维建模源文件、不同风格的测试稿'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'最终可印刷的矢量文件、适用于不同媒介的导出文件（PNG, SVG）、完整的图表标题与数据来源说明'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'被学术论文/教科书/商业报告引用的截图、客户的设计确认邮件、信息图在社交媒体传播的数据截图'
            }
        ]
    },
    {
        id:12,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'模型要表现的对象概念草图、功能或展示目的说明'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'精确的三视图、尺寸标注图、结构分解爆炸图、材料与工艺选择清单'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'3D建模过程文件、3D打印切片文件、手工制作的步骤照片、关节或活动部件测试视频'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'成品多角度高清照片与视频、带比例尺的展示照片、使用说明或背景介绍卡片'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'参展展览的展签与画册、收藏家购买合同、作为产品原型被投资的协议、复制品销售记录'
            }
        ]
    },
    {
        id:13,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'项目构想文档、解决的核心问题描述、市场竞品分析概要'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'详细需求规格说明书、系统架构设计图、数据库ER图、技术选型报告、UI/UX交互原型'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'源代码文件（及版本管理提交记录）、API接口文档、模块开发文档、单元测试用例与报告、第三方库使用清单及许可协议'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'可安装运行的软件包/安装程序、用户手册、系统部署文档、软件著作权登记代码文档、最终测试报告'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'软件著作权登记证书、软件销售/服务合同、开源协议（如GPL）、用户许可协议、版本更新日志、应用商店上架截图'
            }
        ]
    },
    {
        id:0,
        list:[
            {
                index:0,
                title:'创意构思阶段',
                content:'独创性、智力创造性说明文档，明确其不同于现有类型的创新点'
            },
            {
                index:1,
                title:'创作规划阶段',
                content:'详细的作品构成方案、技术或艺术实现路径图、必要的背景研究资料'
            },
            {
                index:2,
                title:'制作执行阶段',
                content:'核心的创作过程记录（如算法训练日志、独特工艺步骤录像）、中间成果样本、测试或实验数据'
            },
            {
                index:3,
                title:'定稿成品阶段',
                content:'该成果的完整最终形态（如AI模型文件及参数、一场行为艺术的完整录像、一个菜系的独创配方文档）'
            },
            {
                index:4,
                title:'发行与衍生阶段',
                content:'行业或社群内的认可证明、商业应用合同、技术秘密许可协议、形成新标准或惯例的证据'
            }
        ]
    }
]
export const dramaStageTipList=[
    {
        index:0,
        title:'创意与策划',
        content:'1 项目策划书（市场定位、目标受众、故事亮点等）；2 故事梗概（1500-3000字，包含思想内涵）；3 人物介绍（主要角色设定）'
    },
    {
        index:1,
        title:'剧本制作',
        content:'1 完整剧本（基本大纲、剧本内容、创作阐述等）；2 剧本承诺书（加盖公章）；3 分镜脚本/视觉预览（可选）'
    },
    {
        index:2,
        title:'拍摄前准备阶段，如合同签订、资产授权等',
        content:'1 团队合同（导演、制片、摄影、美术、动画师等）；2 演员合同、剧本合同、承制合同等；3 拍摄许可证（如有外景，需当地许可）；4 资产授权书（音乐、美术、道具等版权许可）'
    },
    {
        index:3,
        title:'拍摄与制作阶段',
        content:'1 拍摄日程表（可选）；2 现场剧照/工作照（可选，用于宣传备案）；3 临时剪辑片段（可选，用于内部审查）；4 动画制作进度文件（Layout、动画预览）；5 临时配音/音效；6 制作日志等'
    },
    {
        index:4,
        title:'后期制作阶段，如剪辑、配音、特效等',
        content:'1 片头、片尾字幕表；2 分集剧情梗概；3 特定画面/声音使用情况说明；4 主题曲/插曲；5 片酬承诺书；6 成本配置比例报告'
    },
    {
        index:5,
        title:'成片认证阶段',
        content:'将第1集、第2集、第3集、第……的成片视频上传，完成认证'
    }
]